import useRememberRouteParams from '@/hooks/use-remember-route-params'

/**
 * Renders nothing — it exists only to hold the `useLocation()` subscription of
 * `useRememberRouteParams` in its own leaf component. Calling the hook directly
 * in `AppShell` would re-render the whole shell (header, sidebar, main) on every
 * navigation just to write a query string to sessionStorage.
 */
const RouteParamsMemory = () => {
  useRememberRouteParams()
  return null
}

export default RouteParamsMemory
